/* MrCOLOMBO Newsletter-Submit -> Klaviyo Client API
   Bindet alle Forms mit [data-mrc-newsletter-form] auf der Seite.
   Kein hCaptcha, kein Shopify-Form-Helper. Honeypot gegen Bots.
   Endpoint: POST /client/subscriptions/?company_id={ACCOUNT}
   Doc: https://developers.klaviyo.com/en/reference/create_client_subscription

   Per Form optional:
     data-mrc-source="footer|home-tiles|wer-ist|password|..." (Quelle fuer Klaviyo)
   Innerhalb des Form-Wraps:
     input[name="email"]
     input[name="mrc_hp_field"]  (Honeypot, off-screen)
   Geschwister-Elemente innerhalb [data-mrc-newsletter-wrap]:
     [data-mrc-newsletter-success]
     [data-mrc-newsletter-error]
*/
(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'UN32qi';
  var KLAVIYO_LIST_ID = 'Ueke9N';
  var KLAVIYO_REVISION = '2024-10-15';
  var WELCOME_CODE = 'MRC10';
  var WELCOME_MESSAGE = 'Fast geschafft: Bitte bestätige deine Anmeldung per E-Mail. Dein 10%-Code lautet ' + WELCOME_CODE + ' und gilt einmal pro Kunde.';

  function emailValid(e) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
  }
  function show(el) { if (el) el.removeAttribute('hidden'); }
  function hide(el) { if (el) el.setAttribute('hidden',''); }

  function bindForm(form) {
    if (form.dataset.mrcBound === '1') return;
    form.dataset.mrcBound = '1';

    var wrap = form.closest('[data-mrc-newsletter-wrap]') || form.parentElement;
    var success = wrap ? wrap.querySelector('[data-mrc-newsletter-success]') : null;
    var errorEl = wrap ? wrap.querySelector('[data-mrc-newsletter-error]') : null;
    var emailInput = form.querySelector('input[name="email"]');
    var honeypot = form.querySelector('input[name="mrc_hp_field"]');
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    var source = form.dataset.mrcSource || 'unknown';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (errorEl) hide(errorEl);
      if (success) hide(success);

      if (honeypot && honeypot.value.trim() !== '') {
        // Bot: fake-success, kein Submit
        form.style.display = 'none';
        if (success) show(success);
        return;
      }
      if (!emailInput) return;
      var email = emailInput.value.trim();
      if (!emailValid(email)) {
        if (errorEl) {
          errorEl.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
          show(errorEl);
        }
        emailInput.focus();
        return;
      }

      var origLabel = '';
      if (submitBtn) {
        submitBtn.disabled = true;
        var t = submitBtn.querySelector('.mrc-nl-submit-text, .mrc-footer__nl-submit-text');
        if (t) { origLabel = t.textContent; t.textContent = 'Anmelden ...'; }
      }

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    'signup_source': source,
                    'signup_page': location.pathname
                  }
                }
              }
            },
            custom_source: 'Theme: ' + source
          },
          relationships: {
            list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': KLAVIYO_REVISION,
          'Accept': 'application/vnd.api+json'
        },
        body: JSON.stringify(body)
      })
      .then(function (res) {
        if (res.status === 202 || res.ok) {
          form.style.display = 'none';
          if (success) {
            success.textContent = WELCOME_MESSAGE;
            success.setAttribute('role', 'status');
            success.setAttribute('aria-live', 'polite');
            show(success);
          }
          try {
            (window.dataLayer = window.dataLayer || []).push({
              event: 'newsletter_signup', source: source, list_id: KLAVIYO_LIST_ID
            });
          } catch (_) {}
        } else {
          return res.text().then(function (txt) {
            throw new Error('HTTP ' + res.status + ' ' + (txt || '').substring(0, 120));
          });
        }
      })
      .catch(function (err) {
        if (submitBtn) {
          submitBtn.disabled = false;
          var t2 = submitBtn.querySelector('.mrc-nl-submit-text, .mrc-footer__nl-submit-text');
          if (t2 && origLabel) t2.textContent = origLabel;
        }
        if (errorEl) {
          errorEl.textContent = 'Anmeldung fehlgeschlagen. Bitte später erneut versuchen oder schreibe an office@mrcolombo.de.';
          show(errorEl);
        }
        console.warn('[MRC Newsletter]', err);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-mrc-newsletter-form]').forEach(bindForm);
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        document.querySelectorAll('[data-mrc-newsletter-form]:not([data-mrc-bound="1"])').forEach(bindForm);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
